import "./DataIconValueComponent.scss";
import React from "react";

interface DataIconValueComponentProps {
    icon?: any
}

const DataIconValueComponent = (props: React.PropsWithChildren<DataIconValueComponentProps>) => {
    const {icon, children} = props;

    return (
        <div className={'data-icon-value-component'}>
            <div className="data-icon">
                {icon}
            </div>
            <div className="data-value">{children}</div>
        </div>
    );

};

export default DataIconValueComponent;